// @ts-nocheck
/* eslint-disable */
export const M3D_TEXTURE = {
	src: "/img/m3d/elements-3dv2.png",
	ratio: 2,
	mapping: {
		bigMarkerActive: {
			name: "bigMarkerActive",
			x: 0,
			y: 0,
			w: 96,
			h: 132,
			iw: 62, // inner width
			ih: 62, // inner height
			l: 16, // left
			t: 16, // top
			al: 48, // anchor left
			at: 132 // anchor top
		},
		bigMarker: {
			name: "bigMarker",
			x: 96,
			y: 0,
			w: 96,
			h: 132,
			iw: 62, // inner width
			ih: 62, // inner height
			l: 16, // left
			t: 16, // top,
			al: 48, // anchor left
			at: 132 // anchor top
		},
		middleMarkerActive: {
			name: "middleMarkerActive",
			x: 192,
			y: 0,
			w: 64,
			h: 88,
			iw: 56, // inner width
			ih: 56, // inner height
			l: 4, // left
			t: 4, // top
			al: 32, // anchor left
			at: 88 // anchor top
		},
		middleMarker: {
			name: "middleMarker",
			x: 256,
			y: 0,
			w: 64,
			h: 88,
			iw: 56, // inner width
			ih: 56, // inner height
			l: 4, // left
			t: 4, // top
			al: 32, // anchor left
			at: 88 // anchor top
		},
		middleMarkerUniversalActive: {
			name: "middleMarkerUniversalActive",
			x: 320,
			y: 0,
			w: 64,
			h: 88,
			al: 32, // anchor left
			at: 88 // anchor top
		},
		middleMarkerUniversal: {
			name: "middleMarkerUniversal",
			x: 384,
			y: 0,
			w: 64,
			h: 88,
			al: 32, // anchor left
			at: 88 // anchor top
		},
		littleMarkerUniversalActive: {
			name: "littleMarkerUniversalActive",
			x: 448,
			y: 0,
			w: 28,
			h: 40,
			al: 14, // anchor left
			at: 40 // anchor top
		},
		littleMarkerUniversal: {
			name: "littleMarkerUniversal",
			x: 476,
			y: 0,
			w: 28,
			h: 40,
			al: 14, // anchor left
			at: 40 // anchor top
		},
		carSvg: {
			x: 504,
			y: 0,
			w: 48,
			h: 44
		},
		starSvg: {
			x: 552,
			y: 0,
			w: 48,
			h: 44
		},
		userMarksSvg: {
			x: 600,
			y: 0,
			w: 48,
			h: 44
		},
		distanceMeterSvg: {
			x: 648,
			y: 0,
			w: 48,
			h: 44
		},
		bikeSvg: {
			x: 696,
			y: 0,
			w: 48,
			h: 44
		},
		runSvg: {
			x: 744,
			y: 0,
			w: 48,
			h: 44
		},
		walkSvg: {
			x: 792,
			y: 0,
			w: 48,
			h: 44
		},
		homeSvg: {
			x: 504,
			y: 44+7,
			w: 48,
			h: 44
		},
		boatSvg: {
			x: 552,
			y: 44+7,
			w: 48,
			h: 44
		},
		skiCrossCountrySvg: {
			x: 600,
			y: 44+7,
			w: 48,
			h: 44
		},
		skiSvg: {
			x: 648,
			y: 44+7,
			w: 48,
			h: 44
		},
		workSvg: {
			x: 696,
			y: 44+7,
			w: 48,
			h: 44
		},
		photo: {
			name: "photo",
			x: 840,
			y: 0,
			w: 66,
			h: 66,
			iw: 50, // inner width
			ih: 50, // inner height
			l: 3, // left
			t: 3, // top
			al: 29, // anchor left
			at: 66 // anchor top
		},
		circleRed: {
			name: "circleRed",
			x: 840,
			y: 66,
			w: 28,
			h: 28,
			al: 14, // anchor left
			at: 28 // anchor top
		},
		circleWhite: {
			name: "circleWhite",
			x: 868,
			y: 66,
			w: 28,
			h: 28,
			al: 14, // anchor left
			at: 28 // anchor top
		},
		favorite: {
			name: "favorite",
			l: 0, // left
			t: 0, // top,
			x: 744,
			y: 54,
			w: 52,
			h: 52,
			al: 26, // anchor left
			at: 25 // anchor top
		}
	}
};
